import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Split-screen shell for login / sign-up: form on one side, photo + key points on the other.
export default function AuthLayout({ title, subtitle, tabs, children, footer, image, accent = "green", panelTitle, panelPoints = [] }) {
  return (
    <main className="auth-page">
      <div className="container">
        <div className="row g-4 g-xl-5 align-items-stretch justify-content-center">
          <div className="col-lg-6 col-xl-5">
            <div className="auth-form-col">
              {tabs}
              <h1 className="auth-title">{title}</h1>
              {subtitle && <p className="auth-subtitle">{subtitle}</p>}
              {children}
              {footer}
            </div>
          </div>
          <div className="col-lg-6 d-none d-lg-block">
            <div className={`auth-visual auth-visual--${accent}`} aria-hidden="true">
              <img className="auth-visual-img" src={image} alt="" />
              <div className="auth-visual-card">
                <h2>{panelTitle}</h2>
                <ul>
                  {panelPoints.map((point, i) => (
                    <li key={i}>
                      <span className={`auth-check auth-check--${(i % 3) + 1}`}><i className="fa-solid fa-check" /></span>
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

// "I want to learn / I want to teach" switch shown on the sign-up pages.
export function AuthRoleTabs({ active }) {
  const { t } = useTranslation();
  return (
    <div className="auth-tabs" role="tablist">
      <Link to="/signup-student" role="tab" aria-selected={active === "student"} className={`auth-tab${active === "student" ? " is-active" : ""}`}>
        <i className="fa-light fa-graduation-cap" /> {t("auth.tab_learn")}
      </Link>
      <Link to="/signup-tutor" role="tab" aria-selected={active === "teacher"} className={`auth-tab${active === "teacher" ? " is-active" : ""}`}>
        <i className="fa-light fa-chalkboard-user" /> {t("auth.tab_teach")}
      </Link>
    </div>
  );
}

export function PasswordInput({ id, value, onChange, placeholder, autoComplete, invalid }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="auth-password">
      <input
        id={id}
        required
        type={visible ? "text" : "password"}
        className={`auth-input${invalid ? " is-invalid" : ""}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="auth-password-toggle"
        aria-label={visible ? t("auth.hide_password") : t("auth.show_password")}
        onClick={() => setVisible((v) => !v)}
      >
        <i className={visible ? "fa-light fa-eye-slash" : "fa-light fa-eye"} />
      </button>
    </div>
  );
}

export function Spinner() {
  return <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />;
}
